import { render, staticRenderFns } from "./aiMenubar.vue?vue&type=template&id=6a1abb8c&scoped=true&"
import script from "./aiMenubar.vue?vue&type=script&lang=js&"
export * from "./aiMenubar.vue?vue&type=script&lang=js&"
import style0 from "./aiMenubar.vue?vue&type=style&index=0&id=6a1abb8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1abb8c",
  null
  
)

export default component.exports